import { Box } from '@chakra-ui/react'
import CodeEditor from '../Component/CodeEditor'

function CodeEditorPage() {
  return (
    <div className='my-5 py-5 '>
      <div className="container mt-5">
        <Box>
          <CodeEditor />
        </Box>
      </div>
    </div>
  )
}

export default CodeEditorPage
